// extracted by mini-css-extract-plugin
export default {"FormWidth":"form_FormWidth__XvGF7","genderSpan":"form_genderSpan__JLCty"};